let recaptchaPromise = null

function isLoading() {
  return recaptchaPromise !== null
}

function isLoaded() {
  return window.grecaptcha && window.grecaptcha.execute
}

function loadScript(siteKey) {
  recaptchaPromise = new Promise((resolve, reject) => {
    injectScript(siteKey, resolve, reject)
  })

  return recaptchaPromise
}

function injectScript(siteKey, resolve, reject) {
  const script = createScriptElement(siteKey)

  script.onload = () =>
    window.grecaptcha.ready(() => resolve(window.grecaptcha))

  script.onerror = () => {
    recaptchaPromise = null
    reject(new Error("Failed to load reCAPTCHA"))
  }

  document.head.appendChild(script)
}

function createScriptElement(siteKey) {
  const script = document.createElement("script")
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
  script.async = true
  script.defer = true

  return script
}

export async function loadRecaptcha(siteKey) {
  if (isLoading()) return recaptchaPromise
  if (isLoaded()) return window.grecaptcha

  return loadScript(siteKey)
}
